/*
 * Title: 회원초대 서비스
 * Author: KimTaeOh (taeoh.kim@gentlepie.com )
 * Date: 2021-04-03
 * @Object: GentleServiceInviteMember
 * @Property Value
 * - sponserId: 후원인 아이디
 * - sponserName: 후원인 이름
 * @Property Method
 * - selectInviteType: 회원초대방식선택
 * - sponserIsMe: 나를 후원인으로 초대장 생성
 * - sponserIsOther: 다른 사람을 후원인으로 초대장 생성
 */
import GentleApi from "../common/api";
import GentleWidget from "../common/widget";
import GentleUtil from "../common/util";
import GentleLang from "../common/lang";
import GentleComponentBubble from "../component/bubble";
import GentleProxy from "../common/proxy";
import GentleAppState from "../common/appstate";
import language from "../lang";

var GentleServiceProfile = Object.create(GentleWidget, {
  sponserId: { writable: true, configurable: false, enumerable: true },
  sponserName: { writable: true, configurable: false, enumerable: true },
});

GentleServiceProfile.card = function (data) {
  console.log("GentleServiceProfile.card>", data);
  const {
    CustImg,
    CustName,
    CustNo,
    currentMastership,
    maxMastership,
    CenterName,
    button_title,
  } = data;

  let displayButton = "none";
  // if(button_title){
  //     displayButton = 'block'
  // }

  let img = CustImg ? CustImg : "/assets/images/atomy/profile_atomy.png";

  const html = `
    <div class="card-view">
        <div class="login-profile logined">
            <figure>
                <img data-name="selectedImage" id="selectedImage" src="${img}">
            </figure>
            <div>
                <h6>${CustName}</h6>
                <p>${CustNo}</p>
                <ul>
                    <li>${currentMastership}</li>
                    <li>${currentMastership} (${maxMastership})</li>
                    <li>${CenterName}</li>
                </ul>
            </div>
        </div>
        <form class="service-form profile-form" style="display:${displayButton}">
            <input id="profile_image" type="file" name="CustImg" accept="image/*" style="display:none">
            <input type="hidden" name="CustNo" value="${CustNo}">
            <div class="profile-select-container">
                <div class="profile-select">
                    <ul class="profile-list">
                        <!--<li><label for="profile_image" class="profile_image_label"><i class="at-profile at-album"></i></label></li>-->
                        <li><i class="at-profile at-example1" data-originimage="/assets/images/atomy/profile_women.png"></i></li>
                        <li><i class="at-profile at-example2" data-originimage="/assets/images/atomy/profile_women_2.png"></i></li>
                        <li><i class="at-profile at-example3" data-originimage="/assets/images/atomy/profile_men.png"></i></li>
                        <li><i class="at-profile at-example4" data-originimage="/assets/images/atomy/profile_men_2.png"></i></li>
                    </ul>
                    <div class="gentle-button-group" >
                        <div class="wide-button">
                            <button type="button" class="primary default">${button_title}</button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <script type="text/javascript">
        console.log('script');
        $(function() {
            $("#profile_image").on('change', function(){
                console.log('change');
                readURL(this);
            });
        });

        function readURL(input) {
            if (input.files && input.files[0]) {
            var reader = new FileReader();

            reader.onload = function (e) {
                    $('#selectedImage').attr('src', e.target.result);
                }
              reader.readAsDataURL(input.files[0]);
            }
        }
    </script>
    `;

  return html;
};

// 프로필 등록
GentleServiceProfile.main = function (prop, isEdit = false) {
  // isEdit : 수정하기 모드
  {
    const bubble = GentleUtil.notSupported();
    bubble.insert();
    return;
  }    

  const component = Object.create(this);
  let $profile_form;
  let $profile_image;

  let modeButton = 0; // 프로필 완성하기(1), 프로필 이미지 선택 완료(1)
  let selectedImg = "";

  // api
  const request = function () {
    const onSuccess = function (data) {
      console.log("onSuccess>", data);
      switch (data.Status) {
        case 1:
          const { Data } = data;
          console.log("Data>", Data);

          render(Data);
          break;
        default:
          break;
      }
    };

    const onFailed = function (data) {
      console.log("onFailed");
    };

    const proxy = Object.create(GentleProxy);
    proxy.request("userinfo", {}, onSuccess, onFailed);
  };

  const updateImage = function (param) {
    console.log(param);

    let { CustNo, CustImg, isEdit } = param;

    console.log("profile_image>", $profile_image);
    console.log("profile_image.files>", $profile_image[0].files);
    const files = $profile_image[0].files;
    if (files && files.length > 0) {
      console.log("선택한 파일이 잇슴");
      console.log("profile_form>", $profile_form);

      const obj = {
        url: "/atomy-korea/v2/home/myinfo/InputMyIntroChatbot",
        form: $profile_form[0],
        callback: function (data) {
          console.log("done", data);

          if (data.jsonData === 1) {
            param.CustImg = data.imagePath;

            if (isEdit) {
              // editDone({ CustImg, CustName, CustNo, currentMastership, maxMastership, CenterName });
              editDone(param);
            } else {
              // complete({ CustImg, CustName, CustNo, currentMastership, maxMastership, CenterName });
              complete(param);
            }
          } else {
            ///
            inComplete();
          }
        },
      };
      GentleApi.sendMutipartFormData(obj);
      return;
    }

    const onSuccess = function (data) {
      console.log("onSuccess>", data);
      {
        if (isEdit) {
          // editDone({ CustImg, CustName, CustNo, currentMastership, maxMastership, CenterName });
          editDone(param);
        } else {
          // complete({ CustImg, CustName, CustNo, currentMastership, maxMastership, CenterName });
          complete(param);
        }
      }
      switch (data.Status) {
        case 1:
          const { Data } = data;
          console.log("Data>", Data);

          break;
        default:
          break;
      }
    };

    const onFailed = function (data) {
      console.log("onFailed");
    };

    const proxy = Object.create(GentleProxy);

    proxy.request("myinfo", { CustNo, CustImg }, onSuccess, onFailed);
    // proxy.request("userinfo", {CustNo, CustImg:selectedImg}, onSuccess, onFailed );
  };

  const render = function (data) {
    const { persona, custName } = GentleAppState;

    // 버블
    {
      // let html = isEdit
      //   ? GentleLang.translateService(
      //       language.profile,
      //       language.profile.type.BotEdit
      //     )
      //   : GentleLang.translateService(
      //       language.profile,
      //       language.profile.type.Bot,
      //       { name: custName }
      //     );

      let html = GentleLang.translateService(
        language.profile,
        language.profile.type.Bot,
        { name: custName }
      );

      var bubble = Object.create(GentleComponentBubble);
      bubble.createComponent({
        html,
      });
      bubble.insert();
    }

    // 카드
    {
      // const title = GentleLang.translateService(language.profile, language.profile.type.Title) ; // 하위회원 선택
      let button_title = GentleLang.translateService(
        language.profile,
        language.profile.type.Done
      );
      if (isEdit)
        button_title = GentleLang.translateService(
          language.profile,
          language.profile.type.Edit
        );

      // data bind
      // const {
      //   CustName,
      //   CustNo,
      //   CustImg,
      //   CurrentMastership,
      //   MaxMastership,
      //   CenterName,
      // } = data;

      // 2025.3 회원정보
      const { customer } = data;
      const { 
        CustName: name, 
        CustNo: id, 
        // CustImg: img, 누락
        // ?? CurrentMastership: current, 
        // ?? MaxMastership: max, 
        CenterName: centerName
      } = customer;

      // const currentMastership = GentleLang.mastershipType(CurrentMastership);
      // const maxMastership = GentleLang.mastershipType(MaxMastership);
      // 2025.3 직급 타입 변경
      const currentMastership = customer.levelName;
      const maxMastership = customer.maxName;

      const html = GentleServiceProfile.card({
        CustImg,
        CustName,
        CustNo,
        currentMastership,
        maxMastership,
        CenterName,
        button_title,
      });

      // component 초기화. 이 코드 후에 레퍼런스로 접근
      let $container = $(html);

      // const $profileList = component.find('.profile-list');
      component.setPrefix("profile");
      component.init($container);
      component.insert();
      const $profileList = component.find(".profile-list");

      const $button = component.find("button");

      $profile_image = component.find('[name="CustImg"]');
      $profile_form = component.find(".profile-form");

      const $selectedImage = component.find('[data-name="selectedImage"]');

      // 각 프로필 이미지들 셋팅
      const $img1 = component.find(".at-example1");
      const $img2 = component.find(".at-example2");
      const $img3 = component.find(".at-example3");
      const $img4 = component.find(".at-example4");

      const resetSelect = function () {
        $img1.html("");
        $img2.html("");
        $img3.html("");
        $img4.html("");
      };

      const setSelected = function ($btn) {
        resetSelect();
        $btn.html(
          '<img src = "/assets/images/atomy/profile-select.svg"></img>'
        );

        console.log($btn.data("originimage"));
        $selectedImage.attr("src", $btn.data("originimage"));
      };

      {
        $img1.bind("click", function () {
          setSelected($img1);

          selectedImg = $img1.data("originimage");
          console.log(selectedImg);
        });
        $img2.bind("click", function () {
          setSelected($img2);
          selectedImg = $img2.data("originimage");
          console.log(selectedImg);
        });
        $img3.bind("click", function () {
          setSelected($img3);

          selectedImg = $img3.data("originimage");
          console.log(selectedImg);
        });
        $img4.bind("click", function () {
          setSelected($img4);

          selectedImg = $img4.data("originimage");
          console.log(selectedImg);
        });
      }

      // 프로필 완성하기
      {
        const onClickDone = function () {
          if (modeButton === 0) {
            modeButton = 1;

            // 이미지 목록 보여주기
            $profileList.addClass("show");

            // 버튼 텍스트 변경
            {
              const title = GentleLang.translateService(
                language.profile,
                language.profile.type.ImageSelected
              );
              $button.html(title);
            }
          } else if (modeButton === 1) {
            console.log("프로필 이미지 선택 완료");

            // todo : 봇 버블 시나리오가 다르다...
            const arr = window.location.href.split("/");
            console.log(`${arr[0]}//${arr[1]}${arr[2]}/${selectedImg}`);
            if (arr[2] === "localhost:8080") {
              arr[2] = "chat-dev.atomy.kr";
            }

            const CustImg = `${arr[0]}//${arr[1]}${arr[2]}${selectedImg}`;

            updateImage({
              CustNo,
              CustImg,
              isEdit,
              CustName,
              CustImg,
              currentMastership,
              maxMastership,
              CenterName,
            });

            // 이미지 목록 숨기기
            $profileList.removeClass("show");

            // 버튼 숨기기
            component.find(".profile-form").hide();

            // if(isEdit){
            //     editDone({ CustImg, CustName, CustNo, currentMastership, maxMastership, CenterName });
            // }
            // else{
            //     complete({ CustImg, CustName, CustNo, currentMastership, maxMastership, CenterName });
            // }

            {
              const html = GentleLang.translateService(
                language.profile,
                language.profile.type.ImageSelected
              );
              var bubble = Object.create(GentleComponentBubble);
              bubble.insertUserBubble({ html, send: false });
              bubble.insert();
            }
          }
        };
        $button.bind("click", onClickDone);
      }
    }

    GentleUtil.timeStamp();
  };

  const complete = function (data) {
    console.log("complete");
    const {
      CustImg,
      CustName,
      CustNo,
      currentMastership,
      maxMastership,
      CenterName,
    } = data;
    // 버블
    {
      console.log("GentleAppState>", GentleAppState);

      var bubble = Object.create(GentleComponentBubble);
      let html = GentleLang.translateService(
        language.profile,
        language.profile.type.Complete
      );
      bubble.createComponent({
        html,
      });
      bubble.insert();
    }

    // 카드
    {
      const html = GentleServiceProfile.card({
        CustImg,
        CustName,
        CustNo,
        currentMastership,
        maxMastership,
        CenterName,
      });
      const $container = $(html);
      component.insertElement($container);
    }

    // 버블
    {
      const { persona } = GentleAppState;

      var bubble = Object.create(GentleComponentBubble);
      let html = GentleLang.translateService(
        language.profile,
        language.profile.type.Home
      );

      bubble.createComponent({
        html,
      });
      bubble.insert();
    }
    GentleUtil.timeStamp();
  };

  const editDone = function (data) {
    console.log("editDone");
    const {
      CustImg,
      CustName,
      CustNo,
      currentMastership,
      maxMastership,
      CenterName,
    } = data;
    // 버블
    {
      console.log("GentleAppState>", GentleAppState);

      var bubble = Object.create(GentleComponentBubble);
      let html = GentleLang.translateService(
        language.profile,
        language.profile.type.DoneBot
      );
      bubble.createComponent({
        html,
      });
      bubble.insert();
    }

    // 카드
    {
      const html = GentleServiceProfile.card({
        CustImg,
        CustName,
        CustNo,
        currentMastership,
        maxMastership,
        CenterName,
      });
      const $container = $(html);
      component.insertElement($container);
    }
    GentleUtil.timeStamp();
  };

  const inComplete = function () {
    // 버블
    {
      var bubble = Object.create(GentleComponentBubble);
      let html = GentleLang.translateService(
        language.profile,
        language.profile.type.InComplete
      );
      bubble.createComponent({
        html,
      });
      bubble.insert();
    }
    GentleUtil.timeStamp();
  };

  request();
};

// 프로필 수정
GentleServiceProfile.edit = function (data) {
  // 2024-10-08 더 이상 프로필 등록,수정 사용되지 않음
  // GentleServiceProfile.main(null, true);
};

export default GentleServiceProfile;
